import React from 'react';
import {ReviewUnit} from "@onegovbugs/onegov-react-components";
import styles from "./ReviewUnitApplication.module.scss";

export const InterStateContactDetailsReviewUnit = ({props, interStateDetails, title, onEditUrl, interStateType}) => {   

    const addressPostalFinal = (
        (interStateDetails && interStateDetails.address) 
        ? (interStateDetails.address.enterManually === true || interStateDetails.address.international === true) 
              ? (
                    (interStateDetails.address.addressLine + ", ")+
                    (interStateDetails.address.suburb +", ")+
                    ((interStateDetails.address.international === true ? interStateDetails.address.state : interStateDetails.address.state.value) + ", ")+
                    (interStateDetails.address.postcode)+
                    (interStateDetails.address.international === true ? ", " + interStateDetails.address.country : "")
                )
              :(
                interStateDetails.address.details.Address.PartialAddress+", "+interStateDetails.address.details.Address.Country
                )
        :'');

    return (
        <ReviewUnit
            title={title}
            onEdit={() => props.history.push({
                pathname: onEditUrl,
              })}            
            // onEdit={() => props.history.push("/import-export/interstate-individual")}
        >

            {
                interStateType === "Organisation" && 
                <div className={`row ${styles.infoLine}`}>
                    <div className={"col-12 col-md-6"}>
                    <div>
                        <em>{interStateDetails.organisationIdType}</em>
                    </div>
                    <div>{interStateDetails.organisationIdType === 'ABN' ? interStateDetails.abn : interStateDetails.acn }</div>
                    </div>
                    <div className={"col-12 col-md-6"}>
                    <div>
                        <em>Business Name</em>
                    </div>
                    <div>{interStateDetails.organisationBusinessName}</div>
                    </div>  
                </div>          
            }

            <div className={`row ${styles.infoLine}`}>
                <div className={"col-12  col-md-6"}>
                    <div>
                    <em>Title</em>
                    </div>
                    <div className={styles.camelCase}>{interStateDetails.title.value}</div>
                </div>                   
                <div className={"col-12  col-md-6"}>
                    <div>
                    <em>First Name</em>
                    </div>
                    <div className={styles.camelCase}>{interStateDetails.givenName}</div>
                </div>      
            </div>
            <div className={`row ${styles.infoLine}`}>

                <div className={"col-12 col-md-6"}>
                    <div>
                    <em>Last Name</em>
                    </div>
                    <div className={styles.camelCase}>{interStateDetails.surname}</div>
                </div>   

                <div className={"col-12 col-md-6"}>
                    <div>
                    <em>Middle Name</em>
                    </div>
                    <div className={styles.camelCase}>{interStateDetails.middleName}</div>
                </div>                  
      
            </div>
            <div className={`row ${styles.infoLine}`}>

                <div className={"col-12  col-md-6"}>
                    <div>
                    <em>Mobile Number</em>
                    </div>
                    <div>{interStateDetails.mobileNumber}</div>
                </div>   

                <div className={"col-12 col-md-6"}>
                    <div>
                    <em>Daytime Telephone Number</em>
                    </div>
                    <div>{interStateDetails.daytimeTelephoneNumber}</div>
                </div>                
   
            </div>     

            <div className={`row ${styles.infoLine}`}>        

                <div className={"col-12  col-md-6"}>
                    <div>
                    <em>Email Address</em>
                    </div>
                    <div>{interStateDetails.emailAddress}</div>
                </div>       

                <div className={"col-12 col-md-6"}>
                    <div>
                        <em>Postal Address</em>
                    </div>
                    <div>{addressPostalFinal}</div>
                </div>       

            </div>                    
           

        </ReviewUnit>
      
    )
}